import { Box } from "@mui/material";
import CommunitiesTable from "./components/CommunitiesTable";
import EarningsSection from "./components/EarningsSection";

// Manager-of-Managers hub — a single per-community table combining the two MoM
// functions (set the revenue-split cut + manage the community's manager, plus a
// broadcast-to-all-managers action), followed by the MoM's own earnings &
// payouts. FE-first, mock data.
const ManagersHub = () => (
  // Extra top padding on mobile clears the fixed 61px app header so the top
  // content (the broadcast button) isn't hidden behind it.
  <Box sx={{ padding: { xs: "76px 16px 24px", md: "8px 24px 32px" }, display: "flex", flexDirection: "column", gap: "36px" }}>
    <CommunitiesTable />
    <EarningsSection />
  </Box>
);

export default ManagersHub;
